<form name="form" class="row full-height full-width" #form="ngForm">
    <div class="column full-width full-height preview">
        <div *ngIf="statusWarning" class="row full-width warning-conatiner">
            <div class="text">{{statusWarning}}</div>
            <button class="command-button full" (click)="saveAndPublish()">{{changePackageButtonText}}</button>
        </div>

        <app-roulette-preview [roulette]="roulette"></app-roulette-preview>

        <div class="row full-width buttons-container"
            *ngIf="roulette && roulette.GeneralDetails.Status==WebRouletteStatus.notPurched">
            <button class="command-button full" blockButtonToSingleClick
                (click)="saveAndPublish()">{{'ROULETTE.SAVING_AND_POSTING' |
                translate}}</button>
            <button class="command-button" blockButtonToSingleClick
                (click)="saveForm(false)">{{'ROULETTE.SAVING_WITHOUT_POSTING' |
                translate}}</button>
        </div>
        <div class="row full-width buttons-container"
            *ngIf="roulette && roulette.GeneralDetails.Status!=WebRouletteStatus.notPurched">
            <button class="command-button full" blockButtonToSingleClick (click)="saveForm(false)">{{'ROULETTE.SAVE' | translate}}</button>
        </div>
        <span [routerLink]="''" class="fixed-logo desktop"></span>
    </div>
    <div class="roulette-settings-wrapper">
    <app-roulette-settings [roulette]="roulette" [form]="form">

    </app-roulette-settings>
    </div>
</form>